import {
  Box,
  Button,
  Container,
  Notification,
  Paper,
  PasswordInput,
  TextInput,
} from "@mantine/core";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import { useLocation, useNavigate } from "react-router-dom";

import LogoTainan from "images/logo-tainan-3.svg";
import { X } from "tabler-icons-react";
import { loginSucceeded } from "./auth/authSlice";
import { useAppDispatch } from "App/store";
import { useForm } from "@mantine/form";
import { useState } from "react";
import api from "services/api";

import { useEffect } from "react";
import ReactRecaptcha3 from 'react-google-recaptcha3';

type LoginUser = {
  username: string;
  password: string;
  provider: string;
};

const Login = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const from = (location.state as any)?.from?.pathname || "/";

  const form = useForm<LoginUser>({
    initialValues: {
      username: "",
      password: "",
      provider: "",
    },
  });
  const [tabIndex, setTabIndex] = useState(0);

  const [isLoading, setIsLoading] = useState(false);
  const [isShowError, setIsShowError] = useState(false);
  const dispatch = useAppDispatch();

  const handleSubmit = async (values: LoginUser) => {
    setIsLoading(true);
    setIsShowError(false);


    ReactRecaptcha3.getToken().then(async token => {
      //console.log(token)
      // 因為要更新 redux 使用 fetch
      try {
        values.provider = "";
        // 因為要更新 redux 使用 fetch
        const data = await fetch("/api/login", {
          method: "POST",
          body: JSON.stringify(values),
          headers: {
            "content-type": "application/json",
          },
        }).then((res) => res.json());
  
        toggleCaptchaBadge(false);
        dispatch(loginSucceeded(data));
        dispatch(api.util.resetApiState());
  
        navigate(from, { replace: true });

        ReactRecaptcha3.remove();
      } catch (e) {
        // 登入失敗
        setIsLoading(false);
        setIsShowError(true);
      }
    }, error => {
      //console.log(error)   
      // 登入失敗
      setIsLoading(false);
      setIsShowError(true);
    })
  };

  const handleSubmit2 = async (values: LoginUser) => {
    setIsLoading(true);
    setIsShowError(false);


    ReactRecaptcha3.getToken().then(async token => {
      //console.log(token)
      // 因為要更新 redux 使用 fetch
      try {
        values.provider = "ad";
        // 因為要更新 redux 使用 fetch
        const data = await fetch("/api/login", {
          method: "POST",
          body: JSON.stringify(values),
          headers: {
            "content-type": "application/json",
          },
        }).then((res) => res.json());
  
        toggleCaptchaBadge(false);
        dispatch(loginSucceeded(data));
        dispatch(api.util.resetApiState());
  
        navigate(from, { replace: true });
      } catch (e) {
        // 登入失敗
        setIsLoading(false);
        setIsShowError(true);
      }
    }, error => {
      //console.log(error)   
      // 登入失敗
      setIsLoading(false);
      setIsShowError(true);
    })
  };
  const toggleCaptchaBadge = (show: boolean) => {
    const badge = document.getElementsByClassName('grecaptcha-badge')[0];
    if (badge && badge instanceof HTMLElement) {
      badge.style.visibility = show ? 'visible' : 'hidden';
    }
  };
  useEffect(() => {   
    ReactRecaptcha3.init('6Lc5RGQjAAAAAIOCSHeMEsGAwvAV2q1oaGZH7eiV').then(status => {
      // status: success/error
      // success - script is loaded and greaptcha is ready
      // error - script is not loaded
      console.log(status)
      return;
    })
    toggleCaptchaBadge(true);
    return () => toggleCaptchaBadge(false);
   }, [])

  return (
    <Box
      sx={(theme) => ({
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor:
          theme.colorScheme === "dark"
            ? theme.colors.dark[8]
            : theme.colors.gray[1],
        boxShadow: theme.shadows.md,
      })}
    >
      {isShowError && (
        <Box
          sx={{
            position: "fixed",
            top: "1em",
            left: "calc(50% - 195px)",
            width: "390px",
          }}
        >
          <Notification
            icon={<X size={18} />}
            onClose={() => setIsShowError(false)}
            color="red"
          >
            登入失敗
          </Notification>
        </Box>
      )}
      <Container size={420} my={150}>
        {/* <Title
            align="center"
            sx={(theme) => ({
                fontFamily: `Greycliff CF, ${theme.fontFamily}`,
                fontWeight: 900,
            })}
            >
            儀表板管理系統
        </Title>
        <Text color="dimmed" size="sm" align="center" mt={5}>
            若你需要進入管理系統，請洽系統管理員申請。
        </Text> */}
        <img
          src={LogoTainan}
          className="w80 mx-auto"
          alt="台南城市儀表板"
          draggable="false"
        />
        {/* <img src="/static/media/LOGO.d49de1ff82ad78fe320b0661ee0870c2.svg" alt="台南城市儀表板" draggable="false"></img> */}
        <Paper withBorder shadow="md" p={30} mt={30} radius="md">
          <Tabs
            selectedTabClassName="active"
            selectedIndex={tabIndex}
            onSelect={(index) => setTabIndex(index)}
          >
            <TabList>
              <Tab>市府人員登入</Tab>
              <Tab>網站管理員登入</Tab>
            </TabList>
            {/* 市府人員登入 */}
            <TabPanel>
              <form onSubmit={form.onSubmit(handleSubmit2)}>
                <TextInput
                  label="公務入口網帳號"
                  {...form.getInputProps("username")}
                  placeholder="公務入口網帳號"
                  required
                />
                <PasswordInput
                  label="密碼"
                  {...form.getInputProps("password")}
                  placeholder="密碼"
                  required
                  mt="md"
                />
                <Button
                  fullWidth
                  mt="xl"
                  type="submit"
                  color="cyan"
                  loading={isLoading}
                >
                  登入
                </Button>
              </form>
            </TabPanel>
            <TabPanel>
              {/* 網站管理員登入 */}
              <form onSubmit={form.onSubmit(handleSubmit)}>
                <TextInput
                  label="帳號 / 電子郵件"
                  {...form.getInputProps("username")}
                  placeholder="帳號 / 電子郵件"
                  required
                />
                <PasswordInput
                  label="密碼"
                  {...form.getInputProps("password")}
                  placeholder="密碼"
                  required
                  mt="md"
                />
                <Button
                  fullWidth
                  mt="xl"
                  type="submit"
                  color="cyan"
                  loading={isLoading}
                >
                  登入
                </Button>
              </form>
            </TabPanel>
          </Tabs>
        </Paper>
      </Container>
    </Box>
  );
};

export default Login;
